module.exports = __webpack_public_path__ + "static/media/tracking_banner_img.a6d75cc2.png";